import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import { QuoteCartProvider } from '@/context/QuoteCartContext';
import ScrollToTop from '@/components/ScrollToTop';

// V2 Components (now main)
import HeaderV2 from '@/components/v2/HeaderV2';
import FooterV2 from '@/components/v2/FooterV2';
import QuoteDrawerV2 from '@/components/v2/QuoteDrawerV2';

// V2 Pages (now at root)
import HomeV2 from '@/pages/v2/HomeV2';
import ProductsV2 from '@/pages/v2/ProductsV2';
import ProductDetailV2 from '@/pages/v2/ProductDetailV2';
import ServiciosV2 from '@/pages/v2/ServiciosV2';
import ProcesosV2 from '@/pages/v2/ProcesosV2';
import NosotrosV2 from '@/pages/v2/NosotrosV2';
import ContactoV2 from '@/pages/v2/ContactoV2';

// Admin Pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminProducts from '@/pages/admin/AdminProducts';
import AdminFamilies from '@/pages/admin/AdminFamilies';
import AdminServices from '@/pages/admin/AdminServices';
import AdminProcesses from '@/pages/admin/AdminProcesses';
import AdminQuotes from '@/pages/admin/AdminQuotes';
import AdminQuoteDetail from '@/pages/admin/AdminQuoteDetail';

// Public Layout
const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <HeaderV2 />
    <main className="flex-1">{children}</main>
    <FooterV2 />
    <QuoteDrawerV2 />
  </div>
);

function App() {
  // Hide emergent badge
  React.useEffect(() => {
    // Create widget element manually to avoid React conflicts
    const widget = document.createElement('novagente-widget');
    widget.setAttribute('channel', '67239550-28cf-4a41-ac40-4ea9cf6d4347');
    document.body.appendChild(widget);

    // Hide emergent badge
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.setProperty('display', 'none', 'important');
    
    return () => {
      const existingWidget = document.querySelector('novagente-widget');
      if (existingWidget) existingWidget.remove();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <QuoteCartProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomeV2 /></PublicLayout>} />
            <Route path="/productos" element={<PublicLayout><ProductsV2 /></PublicLayout>} />
            <Route path="/producto/:seoUrl" element={<PublicLayout><ProductDetailV2 /></PublicLayout>} />
            <Route path="/servicios" element={<PublicLayout><ServiciosV2 /></PublicLayout>} />
            <Route path="/procesos" element={<PublicLayout><ProcesosV2 /></PublicLayout>} />
            <Route path="/nosotros" element={<PublicLayout><NosotrosV2 /></PublicLayout>} />
            <Route path="/contacto" element={<PublicLayout><ContactoV2 /></PublicLayout>} />

            {/* Redirect old V2 paths to root */}
            <Route path="/v2" element={<Navigate to="/" replace />} />
            <Route path="/v2/*" element={<Navigate to="/" replace />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="productos" element={<AdminProducts />} />
              <Route path="familias" element={<AdminFamilies />} />
              <Route path="servicios" element={<AdminServices />} />
              <Route path="procesos" element={<AdminProcesses />} />
              <Route path="cotizaciones" element={<AdminQuotes />} />
              <Route path="cotizaciones/:id" element={<AdminQuoteDetail />} />
            </Route>
          </Routes>
        </QuoteCartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
